import { render, staticRenderFns } from "./OnboardingStepFinish.vue?vue&type=template&id=3dc09e6e"
import script from "./OnboardingStepFinish.vue?vue&type=script&lang=js"
export * from "./OnboardingStepFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports